import { HopperOctopusOptions } from "./hopperOctopusOptions";

export abstract class HopperOctopusConfiguration {

  protected constructor() {
    this._isInitialized = false;
    this._config = new HopperOctopusOptions();
  }

  initializeAsync(): Promise<void> {
    throw new Error("Method not implemented.");
  };

  isInitialized(): boolean {
    return this._isInitialized;
  }

  getConfig(): HopperOctopusOptions {
    if (!this._isInitialized) {
      throw new Error("O SDK não foi incializado corretamente");
    }

    return this._config;
  };

  getConfigAsync(): Promise<HopperOctopusOptions> {
    throw new Error("Method not implemented.");
  }

  setConfigAsync(config: HopperOctopusOptions): Promise<void> {
    throw new Error("Method not implemented.");
  }

  getAuthToken(): string {
    throw new Error("Method not implemented.");
  };

  protected _isInitialized: boolean;

  protected _config: HopperOctopusOptions;
}
